import * as React from 'react';

import { cn } from '@rematter/ui-web';

type SpreadsheetTableProps = {
  children: React.ReactNode;
  className?: string;
};

export const SpreadsheetTable = ({
  children,
  className,
}: SpreadsheetTableProps) => (
  <table
    className={cn(
      '@SpreadsheetTable w-full table-fixed border-collapse border border-neutral/20 bg-white',
      className,
    )}
  >
    {children}
  </table>
);
